module.exports = __webpack_public_path__ + "static/media/minivan.c9d7e2cc.svg";